module.exports = __webpack_public_path__ + "static/media/Plus-Bright-Red-Secondary.088bfe08.svg";